export function openExternal(url) {
  // Electron path (desktop) – harmless if window.electron is undefined
  if (window?.electron?.openExternal) {
    return window.electron.openExternal(url);
  }

  // Web/SaaS path
  window.open(url, "_blank", "noopener,noreferrer");
}
